var $39167ee9a84b7061$exports = {};
$39167ee9a84b7061$exports = {
  "alert": `Warnhinweis`,
  "dismiss": `Schlie\xdfen`
};
export { $39167ee9a84b7061$exports as default };